export default __webpack_public_path__ + "static/media/no-commission.d160ccb6.jpeg";